function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
import { Component } from 'panel';
import { defineAndMakeJsxFactory } from 'common/util/jsx';
import { panel2react } from 'common/util/react';
import { addToast } from 'common/components/toast-area/toast-manager';
import { Toast } from 'common/components/toast-area';
import { areToastsEqual } from './utils';
interface ToastPortalJsxProps {
  params?: {
    toast: Toast;
  };
}

/**
 * This is the declarative component way to add a toast, directly inside of a template. Internally it uses the classic "addToast" function.
 *
 * The toast is rendered in our global mp-toast-area component
 */
export class ToastPortal extends Component<UnknownObj> {
  constructor() {
    super(...arguments);
    _defineProperty(this, "_toast", null);
  }
  static get attrsSchema() {
    return _objectSpread({}, super.attrsSchema);
  }
  get config() {
    return {
      template: () => null
    };
  }
  set toast(toast: Toast) {
    if (toast && !areToastsEqual(toast, this._toast)) {
      addToast(toast);
    }
    this._toast = toast;
  }
}
export const ToastPortalEl = defineAndMakeJsxFactory<ToastPortalJsxProps>("mp-toast-portal", ToastPortal);
export const ToastPortalReact = panel2react<ToastPortalJsxProps>("mp-toast-portal", ToastPortal);